import { render } from "./EditP1LogisticsModal.vue?vue&type=template&id=2ccae99b&scoped=true"
import script from "./EditP1LogisticsModal.vue?vue&type=script&lang=js"
export * from "./EditP1LogisticsModal.vue?vue&type=script&lang=js"

import "./EditP1LogisticsModal.vue?vue&type=style&index=0&id=2ccae99b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccae99b"]])

export default __exports__